export const CLICK_EVENTS = {
    GENDER_MALE: "cl_lnd_i_am_man",
    GENDER_FEMALE: "cl_lnd_i_am_woman",
    DATE_MONTH: "cl_lnd_date_birth_month_choose",
    DATE_DAY: "cl_lnd_date_birth_day_choose",
    DATE_YEAR: "cl_lnd_date_birth_year_choose",
    DATE_JOIN: "cl_lnd_qm1_main_join",
    SIGN_IN_CLICK: "cl_lnd_date_birth_sign",

    ERR_NO_DATE: "err_lnd_age_nodate",
    ERR_ONLY_DAY: "err_lnd_age_onlyday",
    ERR_ONLY_MONTH: "err_lnd_age_onlymonth",
    ERR_ONLY_YEAR: "err_lnd_age_onlyyear",
    ERR_DAY_MONTH: "err_lnd_age_onlydaymonth",
    ERR_DAY_YEAR: "err_lnd_age_onlydayyear",
    ERR_MONTH_YEAR: "err_lnd_age_onlymonthyear",
};
export const EMAIL_ALREADY_USED = "This email address has already been used.";

export const BIRTHDAY_ERROR_EVENTS = {
    "": CLICK_EVENTS.ERR_NO_DATE,
    "D": CLICK_EVENTS.ERR_ONLY_DAY,
    "M": CLICK_EVENTS.ERR_ONLY_MONTH,
    "Y": CLICK_EVENTS.ERR_ONLY_YEAR,
    "DM": CLICK_EVENTS.ERR_DAY_MONTH,
    "DY": CLICK_EVENTS.ERR_DAY_YEAR,
    "MY": CLICK_EVENTS.ERR_MONTH_YEAR,
};

export const landingId = "91167d00a4c3a29acfb7a6c6711d3b54";